
import { ReducerRegistry } from '../redux';

import { AUTO_RECORD_STOP, FAKE_PARTICPANT_JOINED, FAKE_PARTICPANT_LEFT, INVALID_MEETING_JSON, IS_RECORDING_AND_LIVESTREAMING_ON,
    PRE_REG_API, SET_ACCESS_TOKEN_NATIVE, SET_AUTO_PASSWORD, SET_DESKTOP_APP, SET_IS_SWITCHING_BREAKOUT_ROOM, SET_IS_SWITCHING_TO_MAIN_ROOM, SET_OCCURANCE_ID, SET_PASSWORD_FORM_NATIVE,
    SET_USER_DETAILS,
    SET_VOICE_COMMAND_STRING } from './actionTypes';

const MT_API = 'features/base/mtApi';

const ApiData = {
    pregData: null,
    userDetails: null,
    occurenceId: null,
    accessToken: '',
    passwordForm: {
        on: false,
        conference: null
    },
    desktopapp: 0,
    voiceCommandString: null,
    invalidData: null,
    md5password: null,
    stopAutoRecord: false,
    isSwitchingBreakOutRoom: false,
    isSwitchingToMainRoom: false,
    isRecordingandLivestreamingOn: false,
    sortedRemoteVirtualScreenshareParticipants: new Map(),
    fakeParticipants: new Map(),
    localScreenShare: undefined
};


/**
 * Reduces the Redux actions of the feature base/connection.
 */
ReducerRegistry.register(
    MT_API,
    (state: Object = ApiData, action: Object) => {

        switch (action.type) {
        case PRE_REG_API: {
            return {
                ...state,
                pregData: action.preRegData || null
            };
        }
        case SET_USER_DETAILS: {

            return {
                ...state,
                userDetails: action.userd
            };
        }

        case SET_AUTO_PASSWORD: {
            return {
                ...state,
                md5password: action.md5password
            };
        }

        case AUTO_RECORD_STOP: {
            return {
                ...state,
                stopAutoRecord: action.stopAutoRecord
            };
        }

        case IS_RECORDING_AND_LIVESTREAMING_ON: {
            return {
                ...state,
                isRecordingandLivestreamingOn: action.isRecordingandLivestreamingOn
            };
        }

        case INVALID_MEETING_JSON: {
            return {
                ...state,
                invalidData: action.data
            };
        }

        case SET_OCCURANCE_ID: {
            return {
                ...state,
                occurenceId: action.occurrenceId
            };
        }

        case SET_ACCESS_TOKEN_NATIVE: {
            return {
                ...state,
                accessToken: action.tokn
            };

        }

        case SET_DESKTOP_APP: {
            return {
                ...state,
                desktopapp: action.desktopapp
            };
        }

        case SET_PASSWORD_FORM_NATIVE: {

            return {
                ...state,
                passwordForm: action.formBool
            };
        }


        case SET_VOICE_COMMAND_STRING: {
            return {
                ...state,
                voiceCommandString: action.vsString
            };
        }
        case SET_IS_SWITCHING_BREAKOUT_ROOM : {
            return {
                ...state,
                isSwitchingBreakOutRoom: action.isSwitchingBreakOutRoom
            };
        }

        case SET_IS_SWITCHING_TO_MAIN_ROOM : {
            return {
                ...state,
                isSwitchingToMainRoom: action.isSwitchingToMainRoom
            };
        }

        case FAKE_PARTICPANT_JOINED: {
            const { fakeParticipant, id, name } = action;
            const updatedFakeParticipants = new Map(state.fakeParticipants);

            updatedFakeParticipants.set(id, {
                fakeParticipant,
                name
            });

            // Handle local and remote screenshare
            if (fakeParticipant === 'LocalScreenShare') {
                return {
                    ...state,
                    localScreenShare: { id,
                        name },
                    fakeParticipants: updatedFakeParticipants
                };
            }

            if (fakeParticipant === 'RemoteScreenShare') {
                const updatedRemoteScreenshares = new Map(state.sortedRemoteVirtualScreenshareParticipants);

                updatedRemoteScreenshares.set(id, { id,
                    name });

                return {
                    ...state,
                    sortedRemoteVirtualScreenshareParticipants: updatedRemoteScreenshares,
                    fakeParticipants: updatedFakeParticipants
                };
            }

            return {
                ...state,
                fakeParticipants: updatedFakeParticipants
            };
        }

        case FAKE_PARTICPANT_LEFT: {
            const { id, options } = action;
            const updatedFakeParticipants = new Map(state.fakeParticipants);

            updatedFakeParticipants.delete(id);

            // Handle local screenshare removal
            if (options?.fakeParticipant === 'LocalScreenShare') {
                return {
                    ...state,
                    localScreenShare: undefined,
                    fakeParticipants: updatedFakeParticipants
                };
            }

            // Handle remote screenshare removal
            if (options?.fakeParticipant === 'RemoteScreenShare') {
                const updatedRemoteScreenshares = new Map(state.sortedRemoteVirtualScreenshareParticipants);

                updatedRemoteScreenshares.delete(id);

                return {
                    ...state,
                    sortedRemoteVirtualScreenshareParticipants: updatedRemoteScreenshares,
                    fakeParticipants: updatedFakeParticipants
                };
            }

            return {
                ...state,
                fakeParticipants: updatedFakeParticipants
            };
        }
        }

        return state;
    });
